import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { editPosition } from "../../core/category.core";

export default function CategoryDragRow({ afterId, parentId }: { afterId: string | undefined; parentId: string | undefined }) {
  const [isDragEnter, setIsDragEnter] = useState(false);
  const queryClient = useQueryClient();

  return (
    <div
      onDragEnter={(ev) => {
        ev.preventDefault();
        ev.dataTransfer.dropEffect = "move";
        setIsDragEnter(true);
      }}
      onDragLeave={(ev) => {
        ev.preventDefault();
        setIsDragEnter(false);
      }}
      onDragOver={(ev) => {
        ev.preventDefault();
      }}
      onDrop={(ev) => {
        ev.preventDefault();

        const catId = ev.dataTransfer.getData("text/plain");

        editPosition(catId, parentId, afterId, queryClient).then(() => {
          setIsDragEnter(false);
        });
      }}
      className={`${isDragEnter ? "h-16 bg-gray-200 dark:bg-gray-600 border-dotted border-2" : "h-2 "}`}
    ></div>
  );
}
